/* WD storefront access guard. Server policy decides access; this file never infers visitor IP. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (root && root.document) api.install(root, root.document.currentScript);
}(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var ENDPOINT = 'https://ai.chemeri.com/api/storefront-access/check';
  var HOSTS = {
    'wetchdives.com': 'watchdives', 'www.wetchdives.com': 'watchdives',
    'steeldivewatches.myshopify.com': 'watchdives',
    'militadowatch.com': 'militado', 'www.militadowatch.com': 'militado',
    'baltanywatch.myshopify.com': 'militado'
  };
  var CREDIT_URL = 'https://db-ip.com';
  var CREDIT_TEXT = 'IP Geolocation by DB-IP';
  var LICENSE_URL = 'https://creativecommons.org/licenses/by/4.0/';
  var DEADLINE_MS = 2500;
  var ANONYMOUS_CHINESE_DEADLINE_MS = 12000;
  var ENROLLMENT_DEADLINE_MS = 5000;
  var OPERATOR_FRAGMENT = 'wd_ops_access';
  var STAFF_FRAGMENT = 'wd_staff_access';
  var STAFF_PROBE_FRAGMENT = 'wd_staff_probe';
  var OPERATOR_STORAGE_PREFIX = 'wd-storefront-operator:v2:';
  var LEGACY_STORAGE_PREFIX = 'wd-storefront-operator:v1:';
  var PAUSED_RECHECK_SECONDS = 300;
  var INSTALL_SLOT = '__wdStorefrontAccessGuardV1';
  var INSTALL_OWNER = 'wd-storefront-access/v1';

  function createAccessGuard(win, options) {
    options = options || {};
    var doc = win.document;
    var site = HOSTS[String(win.location.hostname || '').toLowerCase()];
    var themeDisabled = options.enabled === false;
    var eligible = Boolean(site &&
      !options.designMode && !options.visualPreviewMode &&
      !(win.Shopify && (win.Shopify.designMode || win.Shopify.visualPreviewMode)));
    var started = false, destroyed = false, serial = 0, current = null, scheduled = null;
    var state = 'inactive', overlay = null, credit = null, creditLink = null, licenseLink = null;
    var retry = null, previousFocus = null;
    var enrollment = null, operatorSession = null, enrollmentRetries = 0, enrollmentNotice = null;
    var staffCandidate = null, sessionPersisted = false;
    var pausedCheckDone = false, pausedCheckToken = null, pausedCheckAt = 0;
    var connection = win.navigator && win.navigator.connection;
    var endpoint = ENDPOINT;
    // An explicit, trusted installation option supports local QA. URL query strings
    // never configure policy endpoints or grant access.
    if (options.publicApiOrigin) {
      try {
        var parsed = new URL(options.publicApiOrigin);
        var localHttp = parsed.protocol === 'http:' &&
          /^(localhost|127\.0\.0\.1|\[::1\])$/.test(parsed.hostname);
        if ((parsed.protocol === 'https:' || localHttp) && parsed.pathname === '/' &&
            !parsed.search && !parsed.hash && !parsed.username && !parsed.password) {
          endpoint = parsed.origin + '/api/storefront-access/check';
        }
      } catch (_) { /* Invalid optional installation configuration uses the standard endpoint. */ }
    }
    var exchangeEndpoint = endpoint.replace(/\/check$/, '/operator/exchange') + '?credential_version=2';
    var storageKey = OPERATOR_STORAGE_PREFIX + site;
    var legacyStorageKey = LEGACY_STORAGE_PREFIX + site;

    function nowSeconds() {
      return Math.floor((win.Date || Date).now() / 1000);
    }
    function sessionValue(value) {
      if (!value || (value.schema_version !== 1 && value.schema_version !== 2) || value.site !== site ||
          typeof value.session_token !== 'string' || value.session_token.length > 4096 ||
          !/^[A-Za-z0-9._~+\/-]+=*$/.test(value.session_token)) return null;
      if (value.schema_version === 2) {
        if (value.expires_at !== null || Object.keys(value).sort().join(',') !== 'expires_at,schema_version,session_token,site') return null;
      } else if (!Number.isSafeInteger(value.expires_at) || value.expires_at <= nowSeconds()) return null;
      return { schema_version: value.schema_version, site: site, session_token: value.session_token, expires_at: value.expires_at };
    }
    function forgetSession(token) {
      if (!token || (operatorSession && operatorSession.session_token === token)) {
        operatorSession = null; sessionPersisted = false;
      }
      try {
        if (!win.localStorage) return;
        [storageKey, legacyStorageKey].forEach(function (key) {
          var raw = win.localStorage.getItem(key);
          // A late rejection must not erase a newer session shared by another tab.
          if (raw && (!token || JSON.parse(raw).session_token === token)) win.localStorage.removeItem(key);
        });
      } catch (_) { /* Storage is optional. */ }
    }
    function storedSession(revokeMemory) {
      try {
        var storage = win.localStorage;
        if (!storage) return;
        var value = null, memory = operatorSession && !sessionPersisted ? operatorSession : null;
        [storageKey, legacyStorageKey].some(function (key) {
          var raw = storage.getItem(key);
          if (raw === null) return false;
          try { value = raw.length <= 8192 ? sessionValue(JSON.parse(raw)) : null; } catch (_) { value = null; }
          if (value && value.schema_version === (key === storageKey ? 2 : 1)) return true;
          value = null; storage.removeItem(key); return false;
        });
        if (value && memory && memory.schema_version === 2 && value.schema_version === 1 && !revokeMemory) {
          operatorSession = memory; sessionPersisted = false;
        } else if (value) { operatorSession = value; sessionPersisted = true; }
        else {
          if (sessionPersisted || revokeMemory) operatorSession = null;
          sessionPersisted = false;
        }
      } catch (_) { /* Private/storage-disabled browsers retain this page's in-memory session. */ }
    }
    function keepSession(value) {
      operatorSession = value; sessionPersisted = false;
      try {
        if (win.localStorage) {
          var key = value.schema_version === 2 ? storageKey : legacyStorageKey, serialized = JSON.stringify(value);
          // Identical server grants do not generate storage-event request loops.
          if (win.localStorage.getItem(key) !== serialized) win.localStorage.setItem(key, serialized);
          sessionPersisted = true;
        }
      } catch (_) { /* Keep only this page's memory. */ }
    }
    function sessionToken() {
      if (operatorSession && operatorSession.schema_version === 1 && operatorSession.expires_at <= nowSeconds()) forgetSession(operatorSession.session_token);
      return operatorSession && operatorSession.session_token;
    }
    function accessValue(value) {
      if (!value || value.schema_version !== 1 || value.site !== site ||
          typeof value.enabled !== 'boolean' || typeof value.allowed !== 'boolean') return null;
      return value;
    }
    function staffSession(encoded) {
      if (!encoded || encoded.length > 8192 || !/^[A-Za-z0-9_-]+$/.test(encoded)) return null;
      try {
        var decoded = win.atob(encoded.replace(/-/g, '+').replace(/_/g, '/') + '==='.slice((encoded.length + 3) % 4));
        if (win.btoa(decoded).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '') !== encoded) return null;
        var value = JSON.parse(decoded);
        if (!value || Object.keys(value).sort().join(',') !== 'expires_at,schema_version,session_token,site') return null;
        return sessionValue(value);
      } catch (_) { return null; }
    }
    function removeEnrollmentNotice() {
      if (enrollmentNotice) enrollmentNotice.remove();
      enrollmentNotice = null;
    }
    function showEnrollmentNotice() {
      if ((!enrollment && !staffCandidate) || !doc.body || enrollmentNotice) return;
      enrollmentNotice = doc.createElement('div');
      enrollmentNotice.id = 'wd-storefront-operator-notice';
      enrollmentNotice.setAttribute('role', 'status');
      enrollmentNotice.style.cssText = 'position:fixed;right:16px;bottom:16px;z-index:2147482999;max-width:320px;padding:14px;border:1px solid #ded9e8;border-radius:10px;background:#fff;color:#20212a;font:14px/1.5 system-ui,sans-serif;box-shadow:0 2px 12px #0001;';
      var message = doc.createElement('span');
      message.textContent = 'Team access is not enabled yet. ';
      enrollmentNotice.appendChild(message);
      var button = doc.createElement('button');
      button.type = 'button'; button.textContent = 'Try again';
      button.addEventListener('click', function () {
        enrollmentRetries = 0; removeEnrollmentNotice(); refresh();
      });
      enrollmentNotice.appendChild(button);
      doc.body.appendChild(enrollmentNotice);
    }
    function captureEnrollment() {
      if (!site || destroyed) return false;
      var hash = String(win.location.hash || '');
      var parts = hash.replace(/^#/, '').split('&'), kept = [], entries = [], staffEntries = [], probes = [];
      for (var i = 0; i < parts.length; i++) {
        var equals = parts[i].indexOf('='), key = equals < 0 ? parts[i] : parts[i].slice(0, equals);
        try { key = decodeURIComponent(key); } catch (_) { /* Preserve unrelated malformed fragments byte for byte. */ }
        if (key !== OPERATOR_FRAGMENT && key !== STAFF_FRAGMENT && key !== STAFF_PROBE_FRAGMENT) { kept.push(parts[i]); continue; }
        var value = equals < 0 ? '' : parts[i].slice(equals + 1);
        try { value = value.length <= 24576 ? decodeURIComponent(value) : ''; } catch (_) { value = ''; }
        (key === OPERATOR_FRAGMENT ? entries : (key === STAFF_FRAGMENT ? staffEntries : probes)).push(value);
      }
      if (!entries.length && !staffEntries.length && !probes.length) return false;
      if (entries.length || staffEntries.length) {
        enrollment = null; staffCandidate = null;
        enrollmentRetries = 0;
        removeEnrollmentNotice();
      }
      var remaining = kept.join('&'), cleanHash = remaining ? '#' + remaining : '';
      try {
        if (!win.history || typeof win.history.replaceState !== 'function') return false;
        var base = String(win.location.href || '').split('#')[0];
        if (!base) base = String(win.location.pathname || '/') + String(win.location.search || '');
        win.history.replaceState(win.history.state, '', base + cleanHash);
        if (String(win.location.hash || '') !== cleanHash) return false;
      } catch (_) { return false; }
      // Duplicate or malformed entries are removed, but never used as credentials.
      if (entries.length + staffEntries.length === 1) {
        enrollment = entries.length === 1 && /^[A-Za-z0-9_-]{43}$/.test(entries[0]) ? entries[0] : null;
        staffCandidate = staffEntries.length === 1 ? staffSession(staffEntries[0]) : null;
      }
      return true;
    }

    function language() {
      var navigator = win.navigator || {};
      return String(navigator.language || (navigator.languages && navigator.languages[0]) || '').slice(0, 64);
    }
    function anonymousChinese() {
      return !themeDisabled && /^zh(?:[-_]|$)/i.test(language().trim()) && !sessionToken();
    }
    function record(next, reason, policyVersion) {
      state = next;
      doc.documentElement.setAttribute('data-wd-access', next);
      doc.documentElement.setAttribute('data-wd-access-reason', String(reason || '').slice(0, 80));
      doc.documentElement.setAttribute('data-wd-access-policy-version', String(policyVersion || '').slice(0, 80));
    }
    function creditInto(parent) {
      if (!credit) {
        credit = doc.createElement('div');
        credit.id = 'wd-storefront-access-credit';
        credit.style.cssText = 'display:block;position:relative;padding:6px 12px;text-align:center;font:10px/1.5 sans-serif;color:inherit;';
        creditLink = doc.createElement('a');
        creditLink.href = CREDIT_URL;
        creditLink.textContent = CREDIT_TEXT;
        creditLink.target = '_blank';
        creditLink.rel = 'noopener noreferrer';
        creditLink.style.cssText = 'color:inherit;text-decoration:underline;';
        credit.appendChild(creditLink);
        var separator = doc.createElement('span');
        separator.textContent = ' · ';
        credit.appendChild(separator);
        licenseLink = doc.createElement('a');
        licenseLink.href = LICENSE_URL;
        licenseLink.textContent = 'CC BY 4.0';
        licenseLink.target = '_blank';
        licenseLink.rel = 'noopener noreferrer';
        licenseLink.style.cssText = 'color:inherit;text-decoration:underline;';
        credit.appendChild(licenseLink);
      }
      if (parent && credit.parentNode !== parent) parent.appendChild(credit);
    }
    function creditOnPage() {
      // A theme's first footer can belong to a hidden search or cart drawer.
      creditInto(doc.body);
    }
    function focus(element) {
      if (!element || typeof element.focus !== 'function') return;
      try { element.focus({ preventScroll: true }); } catch (_) { element.focus(); }
    }
    function removeOverlay() {
      if (!overlay) return;
      creditOnPage();
      overlay.remove();
      overlay = null; retry = null;
      if (previousFocus && previousFocus.isConnected) focus(previousFocus);
      previousFocus = null;
    }
    function showOverlay(pending, enablingOperator) {
      var first = !overlay;
      if (first) {
        previousFocus = doc.activeElement;
        overlay = doc.createElement('div');
        overlay.id = 'wd-storefront-access-overlay';
        overlay.setAttribute('role', 'dialog');
        overlay.setAttribute('aria-modal', 'true');
        overlay.setAttribute('aria-labelledby', 'wd-storefront-access-title');
        overlay.tabIndex = -1;
        overlay.style.cssText = 'position:fixed;inset:0;z-index:2147483000;box-sizing:border-box;display:flex;align-items:center;justify-content:center;padding:24px;overflow:auto;background:#f7f7fb;color:#20212a;font:16px/1.6 system-ui,sans-serif;';
        doc.body.appendChild(overlay);
      }
      // Only our own overlay is replaced. Storefront forms and the body remain intact.
      overlay.replaceChildren();
      var panel = doc.createElement('div');
      panel.style.cssText = 'box-sizing:border-box;max-width:440px;width:100%;padding:28px;text-align:center;background:#fff;border:1px solid #e8e5ee;border-radius:16px;';
      var title = doc.createElement('h1');
      title.id = 'wd-storefront-access-title';
      title.textContent = pending ? (enablingOperator ? 'Enabling team access…' : 'Please wait…') : 'Access unavailable';
      title.style.cssText = 'margin:0 0 12px;font-size:24px;line-height:1.3;color:inherit;';
      panel.appendChild(title);
      var description = doc.createElement('p');
      description.textContent = pending ? (enablingOperator ? 'Please keep this page open until access is enabled.' : 'Checking store availability.') :
        'Access to this store is currently unavailable. Please contact the store team for assistance.';
      description.style.cssText = 'margin:0 0 20px;font-size:14px;';
      panel.appendChild(description);
      retry = doc.createElement('button');
      retry.type = 'button';
      retry.textContent = pending ? 'Please wait…' : 'Try again';
      retry.disabled = pending;
      retry.style.cssText = 'padding:10px 20px;border:1px solid #ded9e8;border-radius:8px;background:#fff;color:#20212a;font:inherit;cursor:pointer;';
      retry.addEventListener('click', refresh);
      panel.appendChild(retry);
      overlay.appendChild(panel);
      creditInto(panel);
      overlay.setAttribute('aria-busy', pending ? 'true' : 'false');
      if (first || (doc.activeElement && !doc.activeElement.isConnected)) {
        focus(pending ? overlay : retry);
      }
    }
    function allow(reason, policyVersion) {
      record('allowed', reason, policyVersion);
      removeOverlay();
      creditOnPage();
    }
    function trapTab(event) {
      if (!overlay || event.key !== 'Tab') return;
      var items = retry && !retry.disabled ? [retry, creditLink, licenseLink] : [creditLink, licenseLink];
      var index = items.indexOf(doc.activeElement);
      var next = event.shiftKey ? (index <= 0 ? items.length - 1 : index - 1) : (index + 1) % items.length;
      event.preventDefault();
      focus(items[next]);
    }
    function cancelCurrent() {
      if (current) current.cancel();
    }
    function refresh() {
      captureEnrollment();
      if (!started || destroyed || !eligible) return Promise.resolve('inactive');
      storedSession();
      if (scheduled !== null) { win.clearTimeout(scheduled); scheduled = null; }
      var enrolling = Boolean(enrollment);
      var activating = Boolean(enrollment || staffCandidate);
      // A fragment is only a pending credential, never proof of team access.
      var holdAnonymousChinese = anonymousChinese();
      if (themeDisabled && !activating) {
        record('inactive', 'disabled'); removeOverlay();
        var pausedToken = sessionToken() || '';
        if (pausedCheckDone && pausedToken === pausedCheckToken && nowSeconds() - pausedCheckAt < PAUSED_RECHECK_SECONDS) return Promise.resolve('inactive');
        pausedCheckDone = true; pausedCheckToken = pausedToken; pausedCheckAt = nowSeconds();
      }
      var id = ++serial;
      cancelCurrent();
      if (!themeDisabled) creditOnPage();
      if (!themeDisabled && (enrolling || (holdAnonymousChinese && state !== 'blocked'))) {
        removeEnrollmentNotice();
        record('pending', 'checking'); showOverlay(true, enrolling);
      }
      // A denied or unconfirmed anonymous Chinese visit stays covered until a
      // real allow/stop response arrives; a slow connection is not permission.
      if (state === 'blocked' && overlay) creditInto(overlay.firstChild);
      var abort = typeof win.AbortController === 'function' ? new win.AbortController() : null;
      return new Promise(function (resolve) {
        var settled = false;
        var timer;
        var cancelExchange = null;
        var retryTimer = null, resumeEnrollment = null, resumeCheck = null, checkRetries = 0;
        function active() { return !settled && !destroyed && id === serial; }
        var request = {
          cancel: function () {
            finish('superseded');
            if (abort) abort.abort();
          }
        };
        function finish(outcome, payload) {
          if (settled) return;
          settled = true;
          if (timer !== undefined) win.clearTimeout(timer);
          if (retryTimer !== null) { win.clearTimeout(retryTimer); retryTimer = null; }
          if (resumeEnrollment) { var resume = resumeEnrollment; resumeEnrollment = null; resume(null); }
          if (resumeCheck) { var resumeRetry = resumeCheck; resumeCheck = null; resumeRetry(null); }
          if (cancelExchange) { var cancel = cancelExchange; cancelExchange = null; cancel(); }
          if (current === request) current = null;
          if (!destroyed && id === serial && outcome !== 'superseded') {
            if (themeDisabled) {
              record('inactive', 'disabled'); removeOverlay();
              pausedCheckDone = true; pausedCheckToken = sessionToken() || ''; pausedCheckAt = nowSeconds();
              if (activating && (enrollment || staffCandidate)) showEnrollmentNotice();
            } else if (outcome === 'decision' && payload.enabled && !payload.allowed) {
              record('blocked', payload.reason || 'policy_denied', payload.policy_version);
              showOverlay(false);
            } else if (outcome !== 'decision' && anonymousChinese()) {
              record('blocked', outcome === 'timeout' ? 'check_timeout' : 'check_unavailable');
              showOverlay(false);
            } else {
              allow(outcome === 'decision' ? (payload.enabled ? payload.reason : 'disabled') :
                (outcome === 'timeout' ? 'check_timeout' : 'check_unavailable'),
                payload && payload.policy_version);
              if (activating && (enrollment || staffCandidate)) showEnrollmentNotice();
            }
          }
          resolve(outcome);
        }
        current = request;
        timer = win.setTimeout(function () {
          finish('timeout');
          if (abort) abort.abort();
        }, enrolling ? ENROLLMENT_DEADLINE_MS : (holdAnonymousChinese ? ANONYMOUS_CHINESE_DEADLINE_MS : DEADLINE_MS));
        var query = new win.URLSearchParams({ site: site, language: language(), credential_version: '2' });
        function exchange(entry) {
          return new Promise(function (done) {
            var finished = false;
            var failure = { retryable: true, retained: true };
            var exchangeAbort = typeof win.AbortController === 'function' ? new win.AbortController() : null;
            function complete(value) {
              if (finished) return;
              finished = true;
              if (cancelExchange === cancel) cancelExchange = null;
              done(value);
            }
            function cancel() {
              complete(null);
              if (exchangeAbort) exchangeAbort.abort();
            }
            cancelExchange = cancel;
            var init = { method: 'POST', cache: 'no-store', credentials: 'omit', referrerPolicy: 'no-referrer',
              headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify({ site: site, token: entry }) };
            if (exchangeAbort) init.signal = exchangeAbort.signal;
            Promise.resolve().then(function () {
              if (!active() || finished) return null;
              return win.fetch(exchangeEndpoint, init);
            }).then(function (response) {
              if (!active() || finished) return null;
              if (!response || !response.ok) {
                if (response && [400, 401, 403, 413].indexOf(response.status) >= 0) {
                  if (enrollment === entry) enrollment = null;
                  failure = { retryable: false, retained: false };
                } else {
                  failure = { retryable: !response || response.status >= 500, retained: true };
                }
                throw new Error('Operator exchange unavailable');
              }
              return response.json();
            }).then(function (payload) {
              if (!active() || finished || enrollment !== entry) return;
              var value = sessionValue({ schema_version: payload.schema_version, site: payload.site,
                session_token: payload.session_token, expires_at: payload.expires_at });
              if (!value || value.session_token === entry) throw new Error('Operator exchange unavailable');
              var access = accessValue(payload.access);
              if (value.schema_version === 2 && (!access || !access.allowed || access.session_valid !== true)) throw new Error('Operator exchange unavailable');
              keepSession(value);
              if (enrollment === entry) { enrollment = null; enrollmentRetries = 0; }
              removeEnrollmentNotice();
              if (!access || !access.allowed || (access.enabled && access.reason !== 'operator_access') ||
                  (!access.enabled && access.reason !== 'disabled')) access = null;
              complete({ session: value, access: access });
            }).catch(function () { complete(failure); });
          });
        }
        function check(token) {
          var init = { method: 'GET', cache: 'no-store', credentials: 'omit', referrerPolicy: 'no-referrer' };
          if (token) init.headers = { Authorization: 'Bearer ' + token };
          if (abort) init.signal = abort.signal;
          return Promise.resolve().then(function () {
            if (!active()) return null;
            return win.fetch(endpoint + '?' + query.toString(), init);
          }).then(function (response) {
            if (!active()) return null;
            if (!response || !response.ok) {
              var failure = new Error('Access check unavailable');
              failure.retryable = !response || !response.status || response.status === 408 || response.status === 429 || response.status >= 500;
              if (token && response && (response.status === 401 || response.status === 403)) {
                forgetSession(token);
                if (staffCandidate && staffCandidate.session_token === token) staffCandidate = null;
                failure.authorizationRejected = true;
              }
              throw failure;
            }
            return response.json();
          }).then(function (payload) {
            if (!active()) return null;
            if (!accessValue(payload)) {
              throw new Error('Access check unavailable');
            }
            // An enabled service always gives a valid operator session this reason,
            // even at the office. Disabled/unavailable service must not revoke it.
            if (token && staffCandidate && staffCandidate.session_token === token) {
              if (payload.allowed && payload.session_valid === true &&
                  (payload.reason === 'operator_access' || (!payload.enabled && payload.reason === 'disabled'))) keepSession(staffCandidate);
              staffCandidate = null;
            }
            if (token && (payload.session_valid === false || (payload.enabled && (!payload.allowed || payload.reason !== 'operator_access')))) {
              if (operatorSession && operatorSession.session_token === token) forgetSession(token);
            }
            if (payload.allowed && payload.session_valid === true) {
              var companySession = sessionValue(payload.session);
              if (companySession) keepSession(companySession);
            }
            return payload;
          });
        }
        function normalCheck() {
          if (staffCandidate && staffCandidate.schema_version === 1 && staffCandidate.expires_at <= nowSeconds()) staffCandidate = null;
          var token = staffCandidate ? staffCandidate.session_token : sessionToken();
          return check(token).catch(function (error) {
            // An unavailable authenticated request does not establish that a
            // saved company credential is invalid. An anonymous denial after
            // a preflight/transport/5xx/JSON failure would wrongly block staff.
            // Retry anonymously only after an explicit authorization rejection.
            if (themeDisabled || !token || !active() || !error || error.authorizationRejected !== true) throw error;
            return check(null);
          });
        }
        function retryAnonymousCheck() {
          return normalCheck().catch(function (error) {
            if (!active() || !holdAnonymousChinese || checkRetries >= 2 || (error && error.retryable === false)) throw error;
            return new Promise(function (done, reject) {
              resumeCheck = done;
              var delay = checkRetries === 0 ? 500 : 1500;
              retryTimer = win.setTimeout(function () {
                retryTimer = null; resumeCheck = null;
                if (!active()) return done(null);
                checkRetries++;
                retryAnonymousCheck().then(done, reject);
              }, delay);
            });
          });
        }
        function enroll() {
          var entry = enrollment;
          return exchange(entry).then(function (result) {
            if (!active()) return null;
            if (result && result.access) return result.access;
            if (result && result.session) return normalCheck(); // Compatible with an older service.
            if (enrollment === entry && result && result.retained) {
              return new Promise(function (done) {
                resumeEnrollment = done;
                if (result.retryable && enrollmentRetries < 2) {
                  var delay = enrollmentRetries === 0 ? 1000 : 3000;
                  retryTimer = win.setTimeout(function () {
                    retryTimer = null; resumeEnrollment = null;
                    if (!active() || enrollment !== entry) return done(null);
                    enrollmentRetries++;
                    enroll().then(done);
                  }, delay);
                }
                // Otherwise keep the short pending state until the same five-
                // second deadline. The raw entry remains only in this page.
              });
            }
            return themeDisabled ? null : normalCheck();
          });
        }
        var decision = enrollment ? enroll() : retryAnonymousCheck();
        decision.then(function (payload) {
          if (!active()) return null;
          finish('decision', payload);
        }).catch(function () { finish('unavailable'); });
      });
    }
    function schedule(event) {
      if (destroyed || !started || !eligible) return;
      if (themeDisabled && event && (event.type === 'online' || event.type === 'change')) pausedCheckDone = false;
      if (scheduled !== null) win.clearTimeout(scheduled);
      scheduled = win.setTimeout(function () { scheduled = null; refresh(); }, 150);
    }
    function pageShow(event) { if (event && event.persisted) schedule(); }
    function visible() { if (doc.visibilityState === 'visible') schedule(); }
    function hashChange() { if (captureEnrollment()) schedule(); }
    function storageChanged(event) {
      if (!event || (event.key !== null && event.key !== storageKey && event.key !== legacyStorageKey)) return;
      try { if (event.storageArea && event.storageArea !== win.localStorage) return; } catch (_) { return; }
      var before = operatorSession && JSON.stringify(operatorSession);
      storedSession(true);
      if (before === (operatorSession && JSON.stringify(operatorSession))) return;
      schedule();
    }
    function start() {
      captureEnrollment();
      if (started || destroyed || !doc.body) return Promise.resolve('inactive');
      if (!eligible) {
        record('inactive', options.enabled === false ? 'disabled' : (site ? 'editor' : 'unsupported_host'));
        return Promise.resolve('inactive');
      }
      started = true; record(themeDisabled ? 'inactive' : 'idle', themeDisabled ? 'disabled' : 'checking');
      win.addEventListener('online', schedule);
      win.addEventListener('focus', schedule);
      win.addEventListener('languagechange', schedule);
      win.addEventListener('pageshow', pageShow);
      win.addEventListener('hashchange', hashChange);
      win.addEventListener('storage', storageChanged);
      doc.addEventListener('visibilitychange', visible);
      doc.addEventListener('keydown', trapTab, true);
      if (connection && connection.addEventListener) connection.addEventListener('change', schedule);
      return refresh();
    }
    function destroy() {
      destroyed = true; ++serial;
      cancelCurrent();
      if (scheduled !== null) win.clearTimeout(scheduled);
      win.removeEventListener('online', schedule);
      win.removeEventListener('focus', schedule);
      win.removeEventListener('languagechange', schedule);
      win.removeEventListener('pageshow', pageShow);
      win.removeEventListener('hashchange', hashChange);
      win.removeEventListener('storage', storageChanged);
      doc.removeEventListener('visibilitychange', visible);
      doc.removeEventListener('keydown', trapTab, true);
      if (connection && connection.removeEventListener) connection.removeEventListener('change', schedule);
      removeOverlay();
      if (credit) credit.remove();
      removeEnrollmentNotice();
      enrollment = null; operatorSession = null; staffCandidate = null;
      record('inactive', 'stopped');
    }
    // Clear a link credential immediately, without waiting for DOM ready or network.
    captureEnrollment();
    if (eligible) storedSession();
    return { start: start, refresh: refresh, destroy: destroy, getState: function () { return state; } };
  }

  function install(win, script) {
    if (!script) return;
    var root = win.document.documentElement;
    var existing = win[INSTALL_SLOT];
    var owned = existing && existing.owner === INSTALL_OWNER && existing.document === win.document &&
      existing.guard && typeof existing.guard.destroy === 'function';
    if (owned && script.getAttribute('data-enabled') === 'false') {
      existing.guard.destroy();
      if (win[INSTALL_SLOT] === existing) delete win[INSTALL_SLOT];
      root.removeAttribute('data-wd-access-guard-installed');
      existing = null;
    }
    if (existing) return;
    if (root.getAttribute('data-wd-access-guard-installed')) return;
    var guard = createAccessGuard(win, {
      enabled: script.getAttribute('data-enabled') !== 'false',
      designMode: script.getAttribute('data-design-mode') === 'true',
      visualPreviewMode: script.getAttribute('data-visual-preview-mode') === 'true',
      publicApiOrigin: script.getAttribute('data-api-origin') || undefined
    });
    var ready = null;
    var installedGuard = {
      start: guard.start, refresh: guard.refresh, getState: guard.getState,
      destroy: function () {
        if (ready) { win.document.removeEventListener('DOMContentLoaded', ready); ready = null; }
        guard.destroy();
      }
    };
    try {
      Object.defineProperty(win, INSTALL_SLOT, {
        value: { owner: INSTALL_OWNER, document: win.document, guard: installedGuard }, configurable: true
      });
    } catch (_) { return; }
    root.setAttribute('data-wd-access-guard-installed', '1');
    if (win.document.readyState === 'loading') {
      ready = function () {
        win.document.removeEventListener('DOMContentLoaded', ready); ready = null; guard.start();
      };
      win.document.addEventListener('DOMContentLoaded', ready, { once: true });
    } else guard.start();
  }
  return { createAccessGuard: createAccessGuard, install: install };
}));
